module.exports = __webpack_public_path__ + "static/Axiforma-Bold-07f2b1fb4d860739607bd8f49e251c2d.ttf";